import Splide from '@splidejs/splide';

export default {

	init() {
		console.log('init sliders...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	// Set up all standard sliders
	bindEvents() {	
		var elems = document.querySelectorAll('.splide.slider:not([data-splide-ignore])');

		if (elems.length) {
			elems.forEach(function (elem) {
				let slider = new Splide(elem, {
					type: 'loop',
					perPage: 1,
					gap: '2rem',
					autoWidth: true,
					arrows: {
                        prev: '.splide__arrow--prev',
                        next: '.splide__arrow--next',
                    },
					pagination: true,
					trimSpace: true,
					classes: {
						arrows: 'splide__arrows',
						arrow: 'splide__arrow',
						prev: 'splide__arrow--prev',
						next: 'splide__arrow--next',
						pagination: 'splide__pagination',
						page: 'splide__pagination__page',
					},
					breakpoints: {
						1024: {
							gap: '1.5rem',
						}
					}
				});

                slider.on('pagination:mounted', function(data) {
                    
                });
                
                slider.mount();

			});
		}
	},

	

};